export const ru = {
    'answer-several-questions':
        'Ответьте, пожалуйста, на два вопроса по работе бета-версии Директа:',
    'are-camps-functions-difficult-to-find':
        'не усложнился ли доступ к важной функциональности на странице «Мои кампании»?',
    'are-filters-user-friendly': 'насколько удобно работать с фильтрами?',
    cancel: 'Отмена',
    close: 'Закрыть',
    'feedback-icon-hint': 'Оставить отзыв о новом интерфейсе',
    later: 'Позже',
    'promo-content':
        'Теперь можно оставлять обратную связь о бета-версии нового интерфейса Директа.',
    'result-title': 'Спасибо! Ваш отзыв отправлен разработчикам Директа',
    send: 'Отправить',
    'switch-to-old-interface-link': 'Я хочу вернуться в старый интерфейс',
    'thanks-text':
        'Наша бета активно развивается — каждую неделю мы внедряем новые опции и устраняем сложности, о которых написали пользователи. Благодарим вас за участие в тестировании! Ваша обратная связь помогает нам сделать Директ лучше и удобнее.',
    title: 'Обратная связь',
    'we-will-connect-to-you-for-questions':
        'В процессе работы нам может понадобиться дополнительная информация, в этом случае мы свяжемся с Вами отдельно.',
    'write-any-feedback':
        'Ответьте, пожалуйста, на три вопроса по работе бета-версии Директа:<br>- насколько удобно работать с фильтрами?<br>- устраивает ли вас скорость работы нового интерфейса?<br>- полезна ли страница рекомендаций?',
    'write-feedback': 'Написать отзыв'
};
